// @flow

import * as React from 'react'
import { connect, type Connector } from 'react-redux'
import { Container, Label, Segment, Header } from 'semantic-ui-react'
import { DataGrid } from 'react-redux-components'

import authenticatedRequest from '../store/authenticated-request'
import {
  updateUser,
  showUserForm,
  hideUserForm,
  resetPasswordRequest,
  resetPasswordCancel,
  resetPassword,
  deleteUserRequest,
  deleteUserCancel,
  deleteUser,
  createUser,
  setUIMode,
} from '../store/manage-users'
import Modal from '../systemwide/modal'
import UserForm from './user-form'

import type { ReduxState, Dispatch } from '../store'
import type { User } from '../store/manage-users.js'

type OwnProps = {||}

type MappedProps = {|
  hasSelection: boolean,
  currentRecord: User | false,
  formPristine: boolean,
  resetPasswordPending: string,
  deleteUserPending: string,
  mode: $PropertyType<$PropertyType<$PropertyType<ReduxState, 'users'>, 'ui'>, 'mode'>,
|}

const mapStateToProps = (state: ReduxState, ownProps: OwnProps): MappedProps => {
  let hasSelection = state.users.grid.selectedRecords.length > 0
  return {
    hasSelection,
    currentRecord: hasSelection ? state.users.grid.selectedRecords[0] : false,
    formPristine: state.users.form.$form.pristine,
    resetPasswordPending: state.users.ui.resetPasswordPending,
    deleteUserPending: state.users.ui.deleteUserPending,
    mode: state.users.ui.mode,
  }
}

type Props = { dispatch: Dispatch } & MappedProps & OwnProps

class UsersPage extends React.Component<Props> {
  static defaultProps = {}

  columns = [
    { key: 'username', name: 'Username', resizable: false, sortable: true, width: 200 },
    { key: 'fullname', name: 'Nome completo', resizable: false, sortable: true },
    { key: 'email', name: 'eMail', resizable: false, sortable: false },
    { key: 'role', name: 'Livello', resizable: false, sortable: true, width: 140 },
  ]

  startUpdateUser = () => {
    this.props.dispatch(setUIMode('edit'))
    if (this.props.currentRecord) {
      this.props.dispatch(showUserForm(this.props.currentRecord))
    }
  }

  startCreateUser = () => {
    this.props.dispatch(setUIMode('add'))
    this.props.dispatch(showUserForm())
  }

  cancelEdit = () => {
    this.props.dispatch(hideUserForm())
  }

  commitEdit = (user: User) => {
    if (this.props.mode === 'edit') {
      this.props.dispatch(updateUser(user))
    } else if (this.props.mode === 'add') {
      this.props.dispatch(createUser(user))
    }
  }

  resetPasswordRequest = () => {
    if (this.props.currentRecord) {
      this.props.dispatch(resetPasswordRequest(this.props.currentRecord.username))
    }
  }
  resetPasswordCancel = () => {
    this.props.dispatch(resetPasswordCancel())
  }
  resetPassword = () => {
    if (this.props.currentRecord) {
      this.props.dispatch(resetPassword(this.props.currentRecord.username))
    }
  }

  deleteUserRequest = () => {
    if (this.props.currentRecord) {
      this.props.dispatch(deleteUserRequest(this.props.currentRecord.username))
    }
  }
  deleteUserCancel = () => {
    this.props.dispatch(deleteUserCancel())
  }
  deleteUser = () => {
    if (this.props.currentRecord) {
      this.props.dispatch(deleteUser(this.props.currentRecord.username))
    }
  }

  render() {
    return (
      <div style={{ paddingTop: '9ex', height: '100vh', overflow: 'auto' }}>
        <Container>
          <Modal
            open={this.props.resetPasswordPending !== ''}
            header={<Header icon="key" content="Conferma reset password" />}
            content={
              <span>
                {"Resettare la password per l'utente " + this.props.resetPasswordPending + '?'}
                <br />La password sarà resettata e al primo login ne sarà richiesta la modifica
              </span>
            }
            onCancel={this.resetPasswordCancel}
            onConfirm={this.resetPassword}
          />
          <Modal
            open={this.props.deleteUserPending !== ''}
            header={<Header icon="user delete" content="Conferma eliminazione utente" />}
            content={
              <span>
                {"Eliminare l'utente " + this.props.deleteUserPending + '?'}
                <br />Questa operazione è irreversibile
              </span>
            }
            onCancel={this.deleteUserCancel}
            onConfirm={this.deleteUser}
          />
          <Segment padded={false} secondary style={{ height: '90vh', display: 'flex', flexDirection: 'column' }}>
            <Label attached="top" color="blue" size="big" style={{ zIndex: '700' }}>
              Gestione utenti
            </Label>
            <DataGrid
              model="gridUsers"
              request={authenticatedRequest}
              dataUrl="/api/users"
              initialPageSize={5000}
              columns={this.columns}
              onRowAdd={this.startCreateUser}
              onRowEdit={this.startUpdateUser}
              onRowDelete={this.deleteUserRequest}
              sidebarContent={
                <UserForm
                  mode={this.props.mode}
                  pristine={this.props.formPristine}
                  username={this.props.currentRecord ? this.props.currentRecord.username : ''}
                  onCancel={this.cancelEdit}
                  onSubmit={this.commitEdit}
                  onResetPassword={this.resetPasswordRequest}
                />
              }
            />
          </Segment>
        </Container>
      </div>
    )
  }
}

const connector: Connector<OwnProps, MappedProps> = connect(mapStateToProps, null)
export default connector(UsersPage)



// WEBPACK FOOTER //
// ./src/users/manage-users.js